import { ACTION } from './constants';
import request from '../../../../../utils/request';
import {hideMainLoader, showMainLoader} from '../../../../actions';
import {requestConfig} from "../../../../../config/apiResource";
import {decryptAES} from '../Authentication/action';

export function getFundDetails(params){
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.getFundDetails(params))
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.GET_FUND_DETAILS, data: json.data });
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with fund details data: " + error)
            });
    }
}

export function getAllSchemeDetails() {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.getAllSchemeDetails())
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.GET_ALL_SCHEME_DETAILS, data: json.data });
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with all scheme details data: " + error)
            });
    }
}

export function getECartTrendingFundData() {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.getECartTrendingFundData())
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.GET_TRENDING_FUND_JAVA, data: json.data });
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with trending fund data: " + error)
            });
    }
}

export function sendOtpEcart(params) {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.sendOtpEcart(params))
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.SEND_OTP_ECART, data: json.data });
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with ecart send otp data: " + error)
            });
    }
}

export function resendOtpEcart(params) {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.resendOTPJava(params))
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.RESEND_OTP_ECART, data: json.data });
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with ecart resend otp data: " + error)
            });
    }
}
export function updateFolioEcart(params, uuid) {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.updateFolioEcart(params, uuid))
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.UPDATE_ECART_FOLIO_ECART, data: json.data });
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with save pre login data: " + error)
            });
    }
}
export function savePreLoginDataEcart(params, uuid) {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.savePreLoginDataEcart(params, uuid))
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.SAVE_PRELOGIN_ECART, data: json.data });
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with save pre login data: " + error)
            });
    }
}

export function saveKycDataEcart(params) {

    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.saveKycDataEcart(params))
            .then((response) => {
                dispatch(hideMainLoader());
                response && dispatch({ type: ACTION.SAVE_KYC_DATA, data: JSON.parse(response) });
                return JSON.parse(response);
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with save kyc data: " + error)
            });
    }
}

export function getFilterList(){
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.getFilterList())
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.GET_FILTER_LIST, data: json.data });
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with get filter list: " + error)
            });
    }
}
